var User = /** @class */ (function () {
    function User(userId, organisationId, groupId, maxFileSize, userFullName, organisationName) {
        this.userId = userId;
        this.organisationId = organisationId;
        this.groupId = groupId;
        this.maxFileSize = maxFileSize;
        this.userFullName = userFullName;
        this.organisationName = organisationName;
    }
    return User;
}());
export { User };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxjQUNXLE1BQWMsRUFDZCxjQUFzQixFQUN0QixPQUFlLEVBQ2YsV0FBbUIsRUFDbkIsWUFBb0IsRUFDcEIsZ0JBQXdCO1FBTHhCLFdBQU0sR0FBTixNQUFNLENBQVE7UUFDZCxtQkFBYyxHQUFkLGNBQWMsQ0FBUTtRQUN0QixZQUFPLEdBQVAsT0FBTyxDQUFRO1FBQ2YsZ0JBQVcsR0FBWCxXQUFXLENBQVE7UUFDbkIsaUJBQVksR0FBWixZQUFZLENBQVE7UUFDcEIscUJBQWdCLEdBQWhCLGdCQUFnQixDQUFRO0lBQUksQ0FBQztJQUM1QyxXQUFDO0FBQUQsQ0FBQyxBQVJELElBUUMifQ==